// extracted by mini-css-extract-plugin
export default {"Total":"Total_G+YyU","prices":"prices_iZF62","price":"price_4PmOO","plusFee":"plusFee_nskCa"};